import { render, staticRenderFns } from "./View23.vue?vue&type=template&id=8f16be36&scoped=true&"
import script from "./View23.vue?vue&type=script&lang=js&"
export * from "./View23.vue?vue&type=script&lang=js&"
import style0 from "./View23.vue?vue&type=style&index=0&id=8f16be36&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f16be36",
  null
  
)

export default component.exports